<template>
  <div class="mt-5">
    <v-layout>
      <v-flex>
        <v-btn flat :disabled="isProgressing" @click="onBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn
          v-if="!isSaveOnly"
          outline
          color="grey"
          :disabled="disabledSendButton || isProgressing"
          :loading="isSaving"
          @click="onSave"
        >
          <i class="fas fa-save mr-1"></i>
          {{ $t('save_draft') }}
        </v-btn>
        <v-btn
          depressed
          color="primary"
          :disabled="disabledSendButton || isProgressing"
          :loading="isSending"
          @click="onSend"
        >
          <i class="fas fa-paper-plane mr-1"></i>
          {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>
    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('broadcastName') }">
          <input
            v-model="name"
            v-validate="'required'"
            type="text"
            class="form-control"
            name="broadcastName"
            data-vv-name="broadcastName"
            :data-vv-as="$t('Broadcast Name')"
            :placeholder="$t('Broadcast Name')"
          />
          <span v-show="errors.has('broadcastName')" class="text-error">{{
            errors.first('broadcastName')
          }}</span>
        </div>
      </v-container>

      <v-divider></v-divider>

      <v-container>
        <template v-if="loadingEstimate">
          <sync-loader
            :color="$vuetify.theme.primary"
            :size="'8px'"
            style="display: inline-block; margin-bottom: 10px"
          ></sync-loader>
        </template>
        <template v-else>
          <p class="primary-color">
            {{ $t('approximately') }}

            <template v-if="sendtype === 'NTN_BROADCAST'">
              <template v-if="value === false"> N/A </template>
              <tween-num
                v-else
                key="promotion"
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
              ></tween-num>
              <span>&nbsp;{{ $t('users') }}</span>
            </template>
            <template v-else>
              <template
                v-if="
                  ['facebook', 'instagram', ''].includes(groupType.value) && sendtype == 'promotion'
                "
              >
                <tween-num
                  key="promotion"
                  :value="parseInt(estimate_user)"
                  :initial="0"
                  :formatter="numberFormat"
                ></tween-num>
                <span
                  >&nbsp;{{ $t('users') }}&nbsp;({{
                    $t(`Number of users who talked with chatbot within 24 hours`)
                  }})</span
                >
              </template>
              <template v-else>
                <tween-num
                  key="not_promotion"
                  :value="parseInt(total_user)"
                  :initial="0"
                  :formatter="numberFormat"
                ></tween-num>
                <span>&nbsp;{{ $t('users') }}</span>
              </template>
            </template>
          </p>
          <template
            v-if="
              selectedBot.pagetype != 'enterprise' &&
              groupType.value != 'line' &&
              sendtype == 'promotion'
            "
          >
            <div>
              {{
                $t(
                  'Broadcasts will be sent to subscribers who interacts in Messenger with the Business page within 24 hours. If you prefer to send messages to more target users (total no. {total_user}), you are required to use Sponsored Message.',
                  { total_user }
                )
              }}
              <a
                href="https://blog.zwiz.ai/handlefbpolicy2020/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('Click') }}</a
              >
            </div>
          </template>
          <p v-if="groupType.value != 'line'">
            ***
            {{
              $t(
                '(Importing the previous users before installing the chatbot can be applied with premium package only.)'
              )
            }}
          </p>
        </template>
        <multiselect
          v-if="selectedBot.theme != 'universalutilities'"
          v-model="groupType"
          :options="groupTypeOptions"
          label="label"
          :allow-empty="false"
          :searchable="false"
          select-label
          selected-label
          deselect-label
          track-by="label"
          @select="onSelectGroupType"
        ></multiselect>
        <template v-if="isSupportLineBotGroup">
          <multiselect
            v-if="['line', 'line-group'].includes(groupType.value)"
            v-model="groupTypeLine"
            class="mt-2"
            :options="groupTypeOptionsLine"
            label="label"
            :allow-empty="false"
            :searchable="false"
            select-label
            selected-label
            deselect-label
            track-by="label"
            @select="onSelectGroupTypeLine"
          ></multiselect>
        </template>

        <div v-if="groupType.value == 'customize'" style="position: relative">
          <div class="form-control">
            <v-premium-plan-popup
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
              :show-all="false"
              margin-top="65"
            ></v-premium-plan-popup>
            <template>
              <v-radio-group
                v-if="['tcp-broadcast'].includes(selectedBot.type)"
                v-model="filter.tcp_type"
                row
                hide-details
                @change="handleTcpTypeChange"
              >
                <v-radio :label="$t('member')" value="member" color="primary" />
                <v-radio :label="$t('everybody')" value="everybody" color="primary" />
              </v-radio-group>
              <div
                style="
                  border: 1px solid #eee;
                  padding: 5px 10px 0px 10px;
                  border-radius: 10px;
                  margin-top: 15px;
                  background: #fbfbfb;
                "
              >
                <filter-customer
                  v-model="filter"
                  is-broadcast
                  :show-tag-type="true"
                  :hide-main="
                    ['tcp-broadcast'].includes(selectedBot.type) && filter.tcp_type === 'member'
                  "
                  :total_user="total_user"
                  @onChangeStatus="onChangeStatus"
                >
                  <div v-if="selectedBot.theme == 'universalutilities'">
                    <v-divider class="mt-2"></v-divider>
                    <v-layout wrap>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for class="caption">{{ $t('ชื่อจริง') }}</label>
                        <input
                          v-model="filter.uu_name"
                          type="text"
                          :placeholder="$t('ชื่อจริง')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for>{{ $t('ประปา') }}</label>
                        <div v-if="selectedBot.uu_areaname" class="primary--text">
                          {{ selectedBot.uu_areaname }}
                        </div>
                        <template v-else>
                          <multiselect
                            v-model="filter.uu_areaname"
                            :options="areaName"
                            select-label
                            selected-label
                            :searchable="false"
                            deselect-label
                          ></multiselect>
                        </template>
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for class="caption">{{ $t('DMA') }}</label>
                        <input
                          v-model="filter.uu_dma"
                          type="text"
                          :placeholder="$t('DMA')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex
                        v-if="selectedBot.theme == 'universalutilities'"
                        xs12
                        sm4
                        md4
                        class="form-control pa-1 text-xs-left"
                      >
                        <label>{{ $t('Register Status') }}</label>
                        <div
                          class="form-inline form-control"
                          :class="{ 'has-error': errors.has('Context') }"
                        >
                          <multiselect
                            v-model="filter.uu_register_status"
                            :options="['ลงทะเบียน', 'ไม่ลงทะเบียน']"
                            select-label
                            selected-label
                            deselect-label
                            :placeholder="$t('Register Status')"
                          ></multiselect>
                        </div>
                      </v-flex>
                      <v-flex sm12 class="text-xs-center">
                        <template v-if="selectedBot.theme == 'universalutilities'">
                          <div
                            v-if="messageAvailableCount !== false"
                            class="primary--text text-xs-left mt-2"
                            style="display: inline"
                          >
                            <template v-if="loadingLinePushMessageCount">
                              <v-progress-circular
                                color="primary"
                                indeterminate
                              ></v-progress-circular>
                            </template>
                            <template v-else
                              >จำนวนที่เคยส่ง {{ messageAvailableCount }} ข้อความ</template
                            >
                          </div>
                        </template>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div v-if="selectedBot.theme == 'hafele'" slot="append" slot-scope="{ filter }">
                    <v-divider class="mt-2"></v-divider>
                    <v-layout wrap>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp ID') }}</label>
                        <input
                          v-model="filter.emp_id"
                          type="text"
                          :placeholder="$t('Emp ID')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp First Name') }}</label>
                        <input
                          v-model="filter.emp_first_name"
                          type="text"
                          :placeholder="$t('Emp First Name')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp Last Name') }}</label>
                        <input
                          v-model="filter.emp_last_name"
                          type="text"
                          :placeholder="$t('Emp Last Name')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Division') }}</label>
                        <input
                          v-model="filter.division"
                          type="text"
                          :placeholder="$t('Division')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Department') }}</label>
                        <input
                          v-model="filter.department"
                          type="text"
                          :placeholder="$t('Department')"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                    </v-layout>
                  </div>

                  <div v-if="selectedBot.theme === 'yasale'">
                    <v-divider class="my-3"></v-divider>
                    <div class="text-xs-left">
                      <div>{{ $t('member_shop_address') }}</div>
                      <v-layout wrap>
                        <v-flex xs12 sm6 xl3 class="pa-2">
                          <label class="caption">{{ $t('Province') }}</label>
                          <multiselect
                            v-model="filter.province"
                            :options="provinceOptions"
                            :close-on-select="false"
                            multiple
                            :placeholder="$t('Province')"
                          ></multiselect>
                        </v-flex>
                        <v-flex xs12 sm6 xl3 class="pa-2">
                          <label class="caption">{{ $t('Subdistrict') }}</label>
                          <multiselect
                            v-model="filter.subdistrict"
                            :options="subdistrictOptions"
                            :close-on-select="false"
                            multiple
                            :placeholder="$t('Subdistrict')"
                          ></multiselect>
                        </v-flex>
                        <v-flex xs12 sm6 xl3 class="pa-2">
                          <label class="caption">{{ $t('District') }}</label>
                          <multiselect
                            v-model="filter.district"
                            :options="districtOptions"
                            :close-on-select="false"
                            multiple
                            :placeholder="$t('District')"
                          ></multiselect>
                        </v-flex>
                        <v-flex xs12 sm6 xl3 class="pa-2">
                          <label class="caption">{{ $t('Postcode') }}</label>
                          <multiselect
                            v-model="filter.postcode"
                            :options="postcodeOptions"
                            :close-on-select="false"
                            multiple
                            :placeholder="$t('Postcode')"
                          ></multiselect>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>

                  <div
                    v-if="
                      ['tcp-broadcast'].includes(selectedBot.type) && filter.tcp_type === 'member'
                    "
                  >
                    <v-layout row wrap>
                      <v-flex xs4 class="pa-2">
                        <div class="text-xs-left">
                          <label for>{{ $t('Tag') }}</label>
                        </div>

                        <multiselect
                          v-if="tagOptions"
                          v-model="filter.tcp_tags"
                          :options="tagOptions"
                          select-label
                          selected-label
                          :searchable="false"
                          deselect-label
                          :multiple="true"
                          :taggable="true"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs4 class="pa-2">
                        <div class="text-xs-left">
                          <label for>{{ $t('member_level') }}</label>
                        </div>
                        <multiselect
                          v-model="filter.tcp.member_level"
                          :options="tcpMemberLevelOptions"
                          select-label
                          selected-label
                          :searchable="false"
                          deselect-label
                          track-by="value"
                          label="label"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs4 class="pa-2">
                        <div class="text-xs-left">
                          <label for>{{ $t('pdpa') }}</label>
                        </div>
                        <div class="text-xs-left primary--text py-2">
                          {{ filter.tcp.pdpa.label }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                </filter-customer>
              </div>
            </template>
          </div>
        </div>

        <div v-if="selectedBot.type == 'jamsai' && jamsaiUserGroup" class="my-2">
          <div>Jamsai Member</div>
          <multiselect
            v-model="jamsaiValue"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            label="name"
            track-by="id"
            :options="jamsaiUserGroup"
            :multiple="true"
            :taggable="true"
            @tag="addTagJamsaiGroup"
          ></multiselect>
        </div>
      </v-container>

      <!-- Estimate broadcast to customer count -->
      <template
        v-if="
          !isGpfBuddy &&
          !isJuzmatchCrm &&
          (['', 'all', 'facebook', 'instagram'].includes(groupType.value) ||
            (groupType.value == 'customize' && filter.app.value != 'line'))
        "
      >
        <v-divider></v-divider>
        <v-container>
          <div>
            {{ $t('Message Type') }}
            <span v-if="sendtype === 'NTN_BROADCAST'" class="primary-color">
              ( จำนวนโควต้าการบรอดแคสต์คงเหลือ
              <tween-num
                key="promotion"
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily_available)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly_available)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly_available)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
              ></tween-num>
              ผู้ใช้ )
            </span>
          </div>
          <a href="https://blog.zwiz.ai/5typesfbbroadcast/" target="_blank">{{
            $t(
              'To avoid being blocked by Facebook, click here to read more about how to use each Message Type'
            )
          }}</a>
          <v-radio-group v-model="sendtype" class="send-type">
            <v-layout wrap>
              <v-flex xs12 sm6 md4 class="py-2">
                <v-radio
                  key="promotion"
                  :label="$t('Promotional Message (within 24 hours)')"
                  value="promotion"
                  color="primary"
                ></v-radio>
              </v-flex>
              <v-flex v-if="groupType.value !== 'instagram'" xs12 sm6 md4 class="py-2 d-flex">
                <v-radio
                  key="ACCOUNT_UPDATE"
                  value="ACCOUNT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template #label>
                    {{ $t('Account Update') }}
                    <v-chip
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      class="white--text"
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex v-if="groupType.value !== 'instagram'" xs12 sm6 md4 class="py-2">
                <v-radio
                  key="CONFIRMED_EVENT_UPDATE"
                  value="CONFIRMED_EVENT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template #label>
                    {{ $t('Confirmed Event Update') }}
                    <v-chip
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      class="white--text"
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex
                v-if="
                  $store.state.ntnPage.includes(selectedBot.pageid) &&
                  groupType.value !== 'instagram'
                "
                xs12
                sm6
                md4
                class="py-2"
              >
                <v-radio
                  key="NTN_BROADCAST"
                  value="NTN_BROADCAST"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template #label>
                    <div>
                      {{ $t('recurring_notification_broadcasts') }}
                      <v-modal-help>
                        <div slot="body">
                          <img class="responsive-img" src="/static/img/assets/help/NTN-01.jpg" />
                          <div style="padding: 15px">
                            <p class="strong">{{ $t('recurring_notification') }}</p>

                            <span class="ml-4">
                              {{ $t('how_to_set_recurring_notification1') }}
                            </span>
                            <p class="mt-3">
                              {{ $t('how_to_set_recurring_notification2') }}
                            </p>
                            <ol class="ml-4 mt-3" type="1" style="margin-bottom: 15px">
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification3') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification4') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification5') }}
                              </li>
                            </ol>
                          </div>
                        </div>
                      </v-modal-help>
                    </div>
                    <v-chip
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      class="white--text"
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
                <small class="primary-color">{{ $t('remark_recurring_notification') }}</small>
              </v-flex>
              <v-flex v-if="groupType.value !== 'instagram'" xs12 sm6 md4 class="py-2">
                <v-radio
                  key="POST_PURCHASE_UPDATE"
                  value="POST_PURCHASE_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template #label>
                    {{ $t('Post-Purchase Update') }}
                    <v-chip
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      class="white--text"
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>

          <v-dialog v-model="showSponser" max-width="640">
            <v-card>
              <div class="text-xs-right">
                <v-btn fab flat small @click="showSponser = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="text-xs-center">
                  <h4 v-html="$t('If you want to send Promotional Message to all users')"></h4>
                  <v-btn
                    class="mb-2"
                    href="https://blog.zwiz.ai/handlefbpolicy2020/"
                    color="primary"
                    depressed
                    target="_blank"
                    >{{ $t('click here') }}</v-btn
                  >
                  <div class="mb-5 grey--text">
                    {{ $t('to learn “How to use Sponsored Message?”') }}
                  </div>
                  <div class="mb-4">
                    <span class="warning--text">{{ $t('Remark') }}</span>
                    {{ $t('This Message Type must be managed in Facebook Ads Manager') }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-container>
      </template>

      <!-- push notification type -->
      <template
        v-if="
          ['', 'facebook', 'instagram', 'whatsapp'].includes(groupType.value) ||
          (groupType.value == 'line' && groupTypeLine.value != 'line-group')
        "
      >
        <v-divider></v-divider>
        <v-container>
          <div>{{ $t('Notification Setting') }}</div>
          <v-radio-group v-model="pushtype" row>
            <v-radio
              v-tooltip.top="
                $t(
                  'Silent Push notification will display a phone notification without sound. Use it for regular messages that dont require immediate action.'
                )
              "
              :label="$t('silent push')"
              value="SILENT_PUSH"
              color="primary"
            ></v-radio>
            <v-radio
              v-tooltip.top="
                $t(
                  'Regular Push notification will make a sound and display a phone notification. Use it for important messages.'
                )
              "
              :label="$t('regular push')"
              value="REGULAR"
              color="primary"
            ></v-radio>
            <v-radio
              v-tooltip.top="
                $t(
                  'No Push notification will not display a phone notification and make any sound. Use it for messages that dont require immediate action.'
                )
              "
              :label="$t('no push')"
              value="NO_PUSH"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-container>
      </template>

      <v-divider></v-divider>
      <v-container>
        <template v-if="type == 'json'">
          <div>
            <intent-group
              v-model="messages"
              :has-alternative="false"
              :is-welcome="true"
              :available-bubbles="availableBubbles"
              :send-type="sendtype"
              :max-intent="maxIntent"
            ></intent-group>
          </div>
          <div>
            <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>
            <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                v-model="choice"
                :tags="choices"
                style="margin-bottom: 5px"
                :btn-text="$t('Add choice')"
                @tags-changed="addChoices"
                @before-adding-tag="checkQuickReply"
              ></tags>

              <span v-if="errorTag.length > 0" class="text-error">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="type == 'template'">
          <div style="overflow-x: scroll; margin-bottom: 5px">
            <div
              style="margin: 0; overflow: auto"
              :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
            >
              <div
                v-for="(generic, index) in generics"
                :key="'generic_' + index"
                style="float: left; width: 300px; margin-right: 15px"
              >
                <generic-manage
                  v-model="generics[index]"
                  :vkey="index"
                  :is-validate="true"
                  @onDelete="onDeleteGeneric(index)"
                  @onCopy="onCopyGeneric"
                >
                  <move-horizontal
                    slot="move"
                    :index="index"
                    :max="generics.length"
                    style="display: inline-block; margin-top: 0"
                    @onMove="onMove(index, $event)"
                  ></move-horizontal>
                </generic-manage>
              </div>
              <div
                v-if="generics.length < 10"
                style="
                  position: relative;
                  float: left;
                  width: 300px;
                  border: 4px dashed #eee;
                  border-radius: 20px;
                  height: 300px;
                  cursor: pointer;
                "
                @click="addGeneric"
              >
                <div
                  style="
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -10px;
                    margin-top: -23px;
                    font-size: 32px;
                  "
                >
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </template>

        <div class="mt-4">
          <div class="hr"></div>
          <div class="text-xs-center" style="margin: -13px">
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              style="position: relative"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <em
                class="fa"
                :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
              />
            </a>
          </div>

          <div v-show="showAdvanced" style="margin-top: 25px">
            <h4>
              {{ $t('add_or_edit_status_and_tags_after_broadcasting_to_customers') }}
            </h4>
            <div>
              {{ $t('Status') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </div>
            <div
              v-if="selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'"
              class="mt-1 primary--text"
            >
              {{ update_status ? update_status : '-' }}
            </div>
            <template v-else>
              <div
                class="form-control"
                :class="{ 'has-error': errors.has('broadcastUpdateStatus') }"
              >
                <!-- <input
                    type="text"
                    class="form-control"
                    name="broadcastUpdateStatus"
                    data-vv-name="broadcastUpdateStatus"
                    :data-vv-as="$t('Status')"
                    :placeholder="$t('Status')"
                    v-model="update_status"
                  /> -->
                <v-layout wrap>
                  <v-flex sm11>
                    <multiselect
                      v-model="update_status"
                      :options="statusOptions"
                      :multiple="false"
                      :taggable="true"
                      @tag="onSelectStatus"
                    >
                    </multiselect>
                  </v-flex>
                  <v-flex sm1>
                    <v-btn samll icon @click="update_status = null">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <span v-show="errors.has('broadcastUpdateStatus')" class="text-error">{{
                  errors.first('broadcastUpdateStatus')
                }}</span>
              </div>
            </template>

            <div class="mt-3">
              {{ $t('Tag') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </div>

            <template
              v-if="selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'"
            >
              <div v-if="update_tags.length == 0" class="primary--text">
                {{ $t('No tag') }}
              </div>
              <template v-else>
                <template v-for="(tag, tindex) in update_tags">
                  <v-chip
                    :key="`tags_${tindex}`"
                    class="white--text"
                    disabled
                    small
                    color="primary"
                  >
                    {{ tag }}
                  </v-chip>
                </template>
              </template>
            </template>
            <template v-else>
              <tags
                v-if="tagOptions"
                v-model="usertag"
                :combobox="true"
                :tags="usertags"
                :item-option="tagOptions"
                style="margin-bottom: 5px"
                :btn-text="$t('Add tag')"
                @tags-changed="addUserTags"
                @before-adding-tag="checkUserTags"
              ></tags>
              <span v-if="errorUsertag.length > 0" class="text-error">
                <template v-if="errorUsertag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorUsertag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorUsertag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </template>
          </div>
        </div>
      </v-container>

      <v-divider></v-divider>
      <div style="position: relative">
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          :show-all="false"
        ></v-premium-plan-popup>
        <v-container
          :style="{
            'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '230px' : 'auto'
          }"
        >
          <v-layout column class="form-control my-3">
            <v-flex>{{ $t('ข้อความแจ้งเตือน') }}</v-flex>
            <v-flex class="text-xs-right form-control">
              <input v-model="notify" type="text" :placeholder="$t('ข้อความแจ้งเตือน')" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>{{ $t('Schedule Broadcast') }}</v-flex>
            <v-flex class="text-xs-right">
              <label class="toggle-switch small" style="vertical-align: bottom">
                <input
                  type="checkbox"
                  :checked="broadcast.isschedule"
                  @change="onBroadcastSchedule"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </v-flex>
          </v-layout>
          <v-layout v-if="broadcast.isschedule" wrap>
            <v-flex xs6 class="form-control">
              <v-layout wrap>
                <v-flex xs8>
                  <v-menu
                    ref="showScheduleDate"
                    v-model="showScheduleDate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template #activator="{ on }">
                      <input id v-model="scheduleDate" type="text" name readonly v-on="on" />
                    </template>
                    <v-date-picker
                      v-model="scheduleDate"
                      color="primary"
                      @input="showScheduleDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 class="pl-1">
                  <v-menu
                    ref="showScheduleTime"
                    v-model="showScheduleTime"
                    :close-on-content-click="false"
                    :return-value.sync="scheduleTime"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template #activator="{ on }">
                      <input id v-model="scheduleTime" type="text" name readonly v-on="on" />
                    </template>
                    <v-time-picker
                      v-if="showScheduleTime"
                      v-model="scheduleTime"
                      full-width
                      color="primary"
                      :allowed-minutes="allowedStep"
                      @click:minute="$refs.showScheduleTime.save(scheduleTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <v-container>
        <br />
        <div class="text-xs-center" style="margin-bottom: 10px">
          <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
            <em class="far fa-eye" />
            {{ $t('preview') }}
          </a>
          <preview-message
            v-if="showPreview"
            :messages="messages"
            :choice="choices"
            :questions="questions"
            :is-comment="false"
            :comment="''"
            @close="showPreview = false"
          ></preview-message>
          <input
            v-model="messages[0].length"
            v-validate="'min_value:1'"
            type="hidden"
            :name="'messages'"
            :data-vv-as="$t('Broadcast Messages')"
          />
          <div class="form-control mt-4" :class="{ 'has-error': errors.has('messages') }">
            <span v-show="errors.has('messages')" class="text-error">{{
              errors.first('messages')
            }}</span>
          </div>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn color="grey" outline :disabled="isProgressing" @click="onBack">
            <em class="fas fa-chevron-left mr-1" />
            {{ $t('Back') }}
          </v-btn>
          <v-btn
            v-if="!isSaveOnly"
            color="grey"
            outline
            :disabled="disabledSendButton || isProgressing"
            :loading="isSaving"
            @click="onSave"
          >
            <i class="fas fa-save mr-1"></i>
            {{ $t('save_draft') }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :disabled="disabledSendButton || isProgressing"
            :loading="isSending"
            @click="onSend"
          >
            <i class="fas fa-paper-plane mr-1"></i>
            {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
          </v-btn>
        </div>
      </v-container>
    </template>

    <modal-dialog2 v-if="showUpgrade" @close="showUpgrade = false">
      <div slot="body" style="overflow: auto">
        <div style="position: relative">
          <v-premium-plan-popup :inline="true" background-color="white"></v-premium-plan-popup>
        </div>
      </div>

      <div slot="footer">
        <div class="text-xs-center">
          <button
            type="button"
            class="btn btn-flat"
            data-dismiss="modal"
            @click="showUpgrade = false"
          >
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </modal-dialog2>
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from 'vue-tween-number'
import ModalDialog2 from '@/components/elements/ModalDialog2'
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FilterCustomer from '@/components/elements/FilterCustomer'
import { PAGE } from '@/constants/page.js'
import jamsaiApi from '@/api/jamsai.js'
import provinces from '@/data/provinces.json'
import districts from '@/data/districts.json'
import subdistricts from '@/data/subdistricts.json'
import cloneDeep from 'lodash/cloneDeep'
import lineBotGroupApi from '@/api/line-bot-group'
import { FEATURE } from '@/constants/feature.js'
export default {
  components: {
    IntentGroup,
    GenericManage,
    MoveHorizontal,
    TweenNum,
    SyncLoader,
    ModalDialog2,
    Tags,
    Multiselect,
    PreviewMessage,
    FilterCustomer
  },
  props: ['value', 'isSaveOnly', 'isLineGroup'],
  data: function () {
    return {
      jamsaiUserGroup: null,
      jamsaiValue: [],
      statusOptions: [],
      tagOptions: null,
      showSponser: false,
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: null,
      scheduleTime: null,
      showAdvanced: false,

      showPreview: false,
      questions: [],
      tag: '',
      usertag: '',
      singleStatus: '',
      showUpgrade: false,
      broadcast: undefined,
      notify: null,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      update_status: '',
      update_tags: [],
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      // groupTypeOptions: [
      //   {
      //     label: this.$t('All'),
      //     value: ''
      //   },
      //   {
      //     label: this.$t('Facebook'),
      //     value: 'facebook'
      //   },
      //   {
      //     label: this.$t('Line'),
      //     value: 'line'
      //   },
      //   {
      //     label: this.$t('Customize'),
      //     value: 'customize'
      //   }
      // ],
      groupTypeOptionsLine: [
        {
          label: this.$t('Friends'),
          value: 'line'
        },
        {
          label: this.$t('Group'),
          value: 'line-group'
        }
      ],
      intents: [],
      type: 'json',
      tntType: {
        label: this.$t('DAILY'),
        value: 'DAILY'
      },
      groupType: {
        label: this.$t('All'),
        value: ''
      },
      groupTypeLine: {
        label: this.$t('Friends'),
        value: 'line'
      },
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      choice: '',
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      juzmatchAccountOption: [
        {
          label: this.$t('invester'),
          value: 'invester'
        },
        {
          label: this.$t('buyer'),
          value: 'buyer'
        }
      ],
      tntTypeOption: [
        {
          label: this.$t('DAILY'),
          value: 'DAILY'
        },
        {
          label: this.$t('WEEKLY'),
          value: 'WEEKLY'
        },
        {
          label: this.$t('MONTHLY'),
          value: 'MONTHLY'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],
          enable: true
        }
      ],
      filter: undefined,
      errorTag: [],
      errorUsertag: [],
      errorFilterTag: [],
      errorFilterStatus: [],
      estimate_user: 0,
      count_optin_daily: 0,
      count_optin_daily_available: 0,
      count_optin_weekly: 0,
      count_optin_weekly_available: 0,
      count_optin_monthly: 0,
      count_optin_monthly_available: 0,
      total_user: '',
      loadingEstimate: true,

      tcp: {
        pdpaOptions: [
          {
            label: this.$t('All'),
            value: 'all'
          },
          {
            label: this.$t('accept_pdpa'),
            value: true
          },
          {
            label: this.$t('not_accept_pdpa'),
            value: false
          }
        ]
      },
      isSaving: false,
      isSending: false
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      isCoachlab: 'isCoachlab',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    maxIntent() {
      return this.sendtype === 'NTN_BROADCAST' ? 1 : 10
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    },
    messageAvailableCount: function () {
      const vm = this
      if (vm.loadingLinePushMessageCount || vm.selectedBot.theme != 'universalutilities') {
        return false
      }
      if (vm.filter.uu_areaname == '' || vm.filter.uu_areaname == null) {
        return vm.linePushMessageCount.reduce((prev, curr) => {
          prev += parseInt(curr.count)
          return prev
        }, 0)
      }
      var area = vm.linePushMessageCount.find((el) => {
        return el.uu_areaname == vm.filter.uu_areaname
      })
      if (area) {
        return area.count
      } else {
        return 0
      }
    },
    choices: {
      get() {
        const vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          const quickReplies = vm.quick_reply ? vm.quick_reply.split(',') : []
          return quickReplies ? quickReplies.map((val) => ({ text: val }), []) : []
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        if (value) {
          result = value.map((val) => val.text, [])
        }
        vm.quick_reply = result.join(',')
      }
    },
    tags: {
      get() {
        const vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          const tags = vm.filter.tags ? vm.filter.tags.split(',') : []
          let result = []
          if (tags) {
            result = tags.map((tag) => ({ text: tag }), [])
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        if (value) {
          result = value.map((tag) => tag.text)
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        const vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          const status = vm.filter.status ? vm.filter.status.split(',') : []
          return status ? status.map((s) => ({ text: s }), []) : []
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        if (value) {
          result = value.map(function (s) {
            return s.text
          })
        }
        vm.filter.status = result.join(',')
      }
    },
    usertags: {
      get() {
        const vm = this
        try {
          if (
            vm.broadcast &&
            vm.broadcast.update_user_tags !== '' &&
            typeof vm.broadcast.update_user_tags !== 'undefined'
          ) {
            let usertags = []
            usertags = vm.broadcast.update_user_tags.split(',')
            usertags = usertags.filter((el) => {
              return el != ''
            })
            let result = []
            if (usertags) {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            }
            return result
          } else {
            return []
          }
        } catch (error) {
          console.error(error)
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }
        vm.update_tags = result
      }
    },
    areaName: function () {
      return ['agent_aya01', 'agent_aya02'].includes(this.$store.state.userid)
        ? ['ประปาเทศบาลพระนครศรีอยุธยา']
        : ['agent_takhli01', 'agent_takhli02'].includes(this.$store.state.userid)
        ? ['ประปาเทศบาลเมืองตาคลี']
        : ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
    },
    availableBubbles: function () {
      let bubbles = this.$store.state.defaultBubbleList
      if (this.sendtype === 'NTN_BROADCAST') {
        return ['text', 'button', 'image', 'generic', 'video']
      }
      if (this.groupType && this.groupType.value === 'facebook') {
        const tempBubbles = bubbles
        const exceptBubbles = ['line_flex', 'line_imagemap', 'line_sticker']
        const filteredBubble = tempBubbles.filter((item) => !exceptBubbles.includes(item))
        return filteredBubble
      } else if (this.groupType && ['whatsapp'].includes(this.groupType.value)) {
        return ['text', 'button', 'image', 'generic', 'video']
      }
      return bubbles
    },
    groupTypeOptions() {
      let options = []

      if (
        this.isGpfBuddy ||
        this.isJuzmatchCrm ||
        ['tcp-broadcast'].includes(this.selectedBot.type)
      ) {
        options = [
          {
            label: this.$t('Line'),
            value: 'line'
          },
          {
            label: this.$t('Customize'),
            value: 'customize'
          }
        ]
      } else {
        options = [
          {
            label: this.$t('All'),
            value: ''
          },
          ...this.socialChannelOptions.map((social) => {
            return {
              value: social.fullValue,
              label: this.$t(social.text)
            }
          }),
          {
            label: this.$t('Customize'),
            value: 'customize'
          }
        ]
      }

      return options
    },
    provinceOptions() {
      return [...provinces.map((province) => province.name_th)].sort((a, b) =>
        a.localeCompare(b, 'th')
      )
    },
    districtOptions() {
      return [...new Set(districts.map((district) => district.name_th.replace(/^เขต/g, '')))].sort(
        (a, b) => a.localeCompare(b, 'th')
      )
    },
    subdistrictOptions() {
      return [...new Set(subdistricts.map((subdistrict) => subdistrict.name_th))].sort((a, b) =>
        a.localeCompare(b, 'th')
      )
    },
    postcodeOptions() {
      return [...new Set(subdistricts.map((subdistrict) => subdistrict.zip_code))].sort(
        (a, b) => a - b
      )
    },
    tcpMemberLevelOptions() {
      let options = []

      const tempMemberLevel = this.$store.state.tcpMasterData.memberLevel

      if (tempMemberLevel && tempMemberLevel.length > 0) {
        options = [
          {
            label: this.$t('All'),
            value: 'all'
          },
          ...tempMemberLevel.map((level) => {
            return {
              value: level.member_level_id,
              label: level.name
            }
          })
        ]
      }

      return options
    },
    disabledSendButton() {
      if (['tcp-broadcast'].includes(this.selectedBot.type)) {
        if (this.estimate_user < 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isSupportLineBotGroup() {
      return this.selectedBot.line_modular_botid || this.selectedBot.line_access_token
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isProgressing() {
      return this.isSaving || this.isSending
    }
  },
  watch: {
    value: function () {
      this.reset()
    },
    filter: {
      handler: function () {
        if (
          this.groupType.value == 'customize' &&
          this.$store.getters.getPackage == 'premium' &&
          !this.isCoachlab
        ) {
          this.estimateReach(this.groupType.value)
        }
      },
      deep: true
    },
    groupType: function () {},
    showSponser: function (newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.sendtype = 'promotion'
      }
    },
    sendtype: function (newVal) {
      if (newVal == 'sponsered') {
        this.showSponser = true
      }
    }
  },
  mounted: function () {
    var vm = this
    vm.initFilter()
    vm.getUserTagList()
    vm.getUserStatusList()
    vm.reset()

    if (vm.name === '') {
      vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
    }
    let scheduleDate
    if (vm.broadcast.scheduletime) {
      scheduleDate = moment(vm.broadcast.scheduletime)
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = scheduleDate.format('HH:mm')
    } else {
      scheduleDate = moment()
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = parseInt(scheduleDate.format('HH')) + 1 + ':' + '00'
    }

    if (this.value && this.value.notify) {
      vm.notify = this.value.notify
    }

    if (vm.isGpfBuddy || ['tcp-broadcast'].includes(this.selectedBot.type)) {
      vm.groupType = {
        label: vm.$t('Line'),
        value: 'line'
      }
    }

    if (this.value && this.value.m_condition) {
      let a = this.value.m_condition.split('&')
      let b = {}
      a.forEach((v) => {
        let x = v.split('=')
        b[x[0]] = x[1]
      })

      Object.assign(this.filter, b)

      let c = {
        uu_areaname: b.uu_areaname,
        uu_dma: b.uu_dma,
        uu_name: b.uu_name,
        uu_register_status: b.uu_register_status
      }
      Object.assign(this.filter, c)

      if (b.lamy_member_type) {
        const tempArrMemberType = b.lamy_member_type.split(',')
        let tempArr = []

        tempArrMemberType.forEach((type) => {
          if (type === 'all') {
            tempArr.push({
              label: 'ทุก Member Type',
              value: type
            })
          } else {
            tempArr.push({
              label: type,
              value: type
            })
          }
        })

        this.filter.lamy_member_type = tempArr
      }

      if (b.juzmatch_member_role) {
        this.filter.juzmatch_member_role = this.juzmatchAccountOption.find(
          (option) => option.value === b.juzmatch_member_role
        )
      }

      if (b.tcp_pdpa !== null || b.tcp_member_level_id) {
        vm.groupType = {
          label: vm.$t('Customize'),
          value: 'customize'
        }

        if (b.tcp_pdpa !== null) {
          this.filter.tcp.pdpa = this.tcp.pdpaOptions.find((option) => {
            const tcpPdpa = b.tcp_pdpa !== 'all' && b.tcp_pdpa === 'true' ? true : false
            return option.value === tcpPdpa
          })
        }

        if (b.tcp_member_level_id) {
          this.filter.tcp.member_level = this.tcpMemberLevelOptions.find(
            (level) => level.value === b.tcp_member_level_id
          )
        }

        if (b.tags) {
          this.filter.tcp_tags = b.tags.split(',')
        }
      }

      for (const key in b) {
        const lamyFilter = [
          'lamy_product_category',
          'lamy_product_model',
          'lamy_product_name',
          'lamy_product_size',
          'lamy_product_head_type',
          'lamy_product_colour'
        ]

        if ([...lamyFilter].includes(key)) {
          vm.filter[key] = b[key].split(',')
        }
      }

      if (b.gpf_company_code) {
        vm.groupType = {
          label: vm.$t('Customize'),
          value: 'customize'
        }
      }

      if (vm.selectedBot.theme === 'yasale') {
        Object.entries(b)
          .filter(
            ([key, value]) =>
              ['province', 'subdistrict', 'district', 'postcode'].includes(key) && value
          )
          .forEach(([key, value]) => {
            vm.filter[key] = value.split(',')
          })
      }
    }
    if (vm.selectedBot.type == 'jamsai') {
      vm.initJamsai()
    }
    if (vm.isLineGroup) {
      vm.groupType = {
        label: this.$t('Line'),
        value: 'line'
      }
      vm.groupTypeLine = {
        label: this.$t('Group'),
        value: 'line-group'
      }
    }
  },
  methods: {
    createInitialFilter() {
      return {
        specialcondition: '',
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        tagtype: 'includes',
        status: '',
        statustype: 'includes',
        lamySendNotiMember: false,
        lamyDaySendNoti: '',
        lamy_member_type: '',
        lamy_interested_product_type: '',
        lamy_total_purchase_from: '',
        lamy_total_purchase_to: '',
        lamy_total_product_purchase_from: '',
        lamy_total_product_purchase_to: '',
        lamy_product_category: '',
        lamy_product_model: '',
        lamy_product_name: '',
        lamy_product_size: '',
        lamy_product_head_type: '',
        lamy_product_colour: '',
        member_status: 'active',
        gpf_company_code: {
          company_code: 'All',
          company_name: 'All',
          groups: []
        },
        gpf_group_code: {
          group_code: 'All',
          group_name: 'All',
          departments: []
        },
        gpf_department_code: {
          department_code: 'All',
          department_name: 'All',
          positions: []
        },
        gpf_position_code: { position_code: 'All', position_name: 'All' },
        toa_member_tier: '',
        juzmatch_member_role: '',
        ...(this.$store.state.selectedBot.theme === 'yasale' && {
          province: [],
          subdistrict: [],
          district: [],
          postcode: []
        }),
        ...(this.selectedBot.type === 'tcp-broadcast' && {
          tcp_member_level_id: '',
          tcp_pdpa: '',
          tcp_tags: [],
          tcp_type: 'member',
          tcp: {
            member_level: {
              label: this.$t('All'),
              value: 'all'
            },
            pdpa: {
              label: this.$t('accept_pdpa'),
              value: true
            }
          }
        }),
        include_page_audience_ids: [],
        ...(this.isFacebookConversionConnected && {
          filter_event_data_value: {},
          filter_event_data_quantity: {},
          filter_event_data_time: {}
        })
      }
    },
    initFilter() {
      this.filter = this.createInitialFilter()
    },
    async initJamsai() {
      const vm = this
      await vm.getJamsaiGroup()
      if (vm.value.groupidlist) {
        try {
          const ids = JSON.parse(vm.value.groupidlist)
          const selectedGroup = vm.jamsaiUserGroup.filter((x) => ids.includes(x.id))
          vm.jamsaiValue = selectedGroup
        } catch (error) {
          console.error(error)
        }
      }
    },
    async getJamsaiGroup() {
      try {
        const response = await jamsaiApi.getJamsaiCustomerGroup(this.selectedBot.pageid)
        if (response.data && response.data.data) {
          this.jamsaiUserGroup = response.data.data
        }
      } catch (error) {
        this.$swal.fire({
          title: 'fail to load customer group',
          type: 'error'
        })
      }
    },
    onSelectStatus(value) {
      this.update_status = value
    },
    checkUserTags(obj) {
      console.log(obj)
      this.errorUsertag = []
      if (obj.tag.text.length > 20) {
        this.errorUsertag.push('overmaxlength')
        obj.error('overmaxlength:20')
      } else if (this.choices.length >= 10) {
        this.errorUsertag.push('overtagmax')
        obj.error('overtagmax:10')
      } else if (obj.tag.isDuplicate) {
        this.errorUsertag.push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = response.result.map((item) => {
          return item.name
        })
      }
    },

    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    addTagJamsaiGroup(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      }
      this.jamsaiUserGroup.push(tag)
      this.jamsaiValue.push(tag)
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.update_tags.push(tag)
    },
    allowedStep: (m) => m % 10 === 0,
    onChangeStatus() {
      if (this.groupType === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(this.groupType)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(
          this.groupType && this.groupType.value ? this.groupType.value : this.groupType
        )
      }
    },
    onBroadcastSchedule() {
      this.$set(this.broadcast, 'isschedule', !this.broadcast.isschedule)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 99999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    addChoices: function (newTags) {
      this.choices = newTags
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error('overmaxlength:20')
      } else if (this.choices.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error('overtagmax:10')
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    onOptionChange: function (option) {
      this.type = option
    },
    onDeleteGeneric: function (index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Generic Message cannot be less than 1')
      }
    },
    onCopyGeneric(generic) {
      if (this.generics.length < 10) {
        this.generics.push(cloneDeep(generic))
      } else {
        this.$root.vtoast.show({
          message: this.$t('Generic Message cannot be more than 10 items'),
          color: 'error',
          icon: 'error'
        })
      }
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function () {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        })
      }
    },
    onBack: function () {
      var vm = this
      vm.$emit('onClose')
    },
    onSave: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        vm.isSaving = true
        vm.updateBroadcast(false, function (status) {
          if (status) {
            vm.$swal.fire({
              title: vm.$t('Success! Broadcast {name} save', {
                // eslint-disable-next-line no-useless-escape
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          } else {
            vm.$swal.fire({
              title: vm.$t('Oop! Broadcast {name} save draft fail', {
                // eslint-disable-next-line no-useless-escape
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          }

          $('html, body').animate({ scrollTop: 0 })

          vm.isSaving = false
        })
      })
    },
    onSend: function () {
      const vm = this

      vm.$validator.validateAll().then(async (result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.groupType.value === 'customize' && vm.$store.getters.getPackage !== 'premium') {
          vm.showUpgrade = true
          return false
        }

        let resultNotice

        if (vm.isGpfBuddy) {
          resultNotice = await vm.$swal.fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              // eslint-disable-next-line no-useless-escape
              name: vm.name.replace(/\<|\>/g, '')
            }),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        } else {
          resultNotice = await vm.$swal.fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              // eslint-disable-next-line no-useless-escape
              name: vm.name.replace(/\<|\>/g, '')
            }),
            html: `<small><span class="warning--text">${vm.$t('Warning!')}</span>${vm.$t(
              'If you send too many broadcasts,your inbox might not be able to access temporarily.'
            )}<small>
            <div class="subheading mt-2" style="line-height: 27px !important;">
            <span class="warning--text">${vm.$t('Warning!')}</span>
            ${vm.$t(
              'You messages must follow the Message Type’s regulation. To avoid being blocked by Facebook, please recheck them before sending the broadcast.'
            )}</div>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }

        if (resultNotice.value) {
          vm.isSending = true
          vm.updateBroadcast(true, function (status) {
            if (status) {
              vm.$swal
                .fire({
                  title: vm.$t('Broadcast {sent_name} sent', {
                    // eslint-disable-next-line no-useless-escape
                    sent_name: vm.name.replace(/\<|\>/g, '')
                  }),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                .then(function () {
                  vm.$emit('onClose', vm.name)

                  if (['tcp-broadcast'].includes(this.selectedBot.type)) {
                    vm.$emit('onSent')
                  }
                })
            } else {
              vm.$swal.fire({
                title: vm.$t('Oop! Broadcast {name} save draft fail', {
                  // eslint-disable-next-line no-useless-escape
                  name: vm.name.replace(/\<|\>/g, '')
                }),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
            }
            vm.isSending = false
          })
        }
      })
    },
    updateBroadcast: function (isSend, callback) {
      var vm = this
      var scheduletime = moment(vm.scheduleDate + ' ' + vm.scheduleTime)
      var scheduletimeUTC = moment.utc(scheduletime)
      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype,
        update_status: vm.update_status,
        notify: vm.notify,
        update_tags: vm.update_tags.join(',')
      }

      if (vm.selectedBot.type == 'jamsai') {
        data.jamsai_group_id = vm.jamsaiValue.map((x) => x.id)
      }

      if (vm.sendtype === 'NTN_BROADCAST') {
        if (vm.tntType.value === 'DAILY') {
          data.sendtype = 'opt_in_daily'
        } else if (vm.tntType.value === 'WEEKLY') {
          data.sendtype = 'opt_in_weekly'
        } else if (vm.tntType.value === 'MONTHLY') {
          data.sendtype = 'opt_in_monthly'
        } else {
          data.sendtype = false
        }
      }

      if (vm.$store.getters.getPackage == 'premium' && !vm.isCoachlab) {
        data.isschedule = vm.broadcast.isschedule
        data.scheduletime = scheduletimeUTC.format('YYYY-MM-DDTHH:mm:ss.sssZ')
      } else {
        data.isschedule = false
        data.scheduletime = null
      }
      if (vm.groupType.value === 'customize') {
        data.filter = vm.filter
        if (vm.selectedBot.theme === 'yasale') {
          data.filter.province = data.filter.province.toString()
          data.filter.subdistrict = data.filter.subdistrict.toString()
          data.filter.district = data.filter.district.toString()
          data.filter.postcode = data.filter.postcode.toString()
        }
      } else {
        data.m_condition = `app=${vm.groupType.value}`
      }

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }

      if (vm.isLamy) {
        if (vm.filter.lamySendNotiMember) {
          data.lamy_member_expired_status = vm.filter.lamySendNotiMember
          data.lamy_member_expired_day = vm.filter.lamyDaySendNoti
        } else {
          data.lamy_member_expired_status = vm.filter.lamySendNotiMember
        }

        if (vm.filter.lamy_member_type) {
          data.lamy_member_type = vm.filter.lamy_member_type
        }

        if (vm.filter.lamy_interested_product_type) {
          data.lamy_interested_product_type = vm.filter.lamy_interested_product_type
        }

        if (vm.filter.lamy_total_purchase_from) {
          data.lamy_total_purchase_from = vm.filter.lamy_total_purchase_from
        }

        if (vm.filter.lamy_total_purchase_to) {
          data.lamy_total_purchase_to = vm.filter.lamy_total_purchase_to
        }

        if (vm.filter.lamy_total_product_purchase_from) {
          data.lamy_total_product_purchase_from = vm.filter.lamy_total_product_purchase_from
        }

        if (vm.filter.lamy_total_product_purchase_to) {
          data.lamy_total_product_purchase_to = vm.filter.lamy_total_product_purchase_to
        }

        if (vm.filter.lamy_product_category) {
          data.lamy_product_category = vm.filter.lamy_product_category
        }

        if (vm.filter.lamy_product_model) {
          data.lamy_product_model = vm.filter.lamy_product_model
        }

        if (vm.filter.lamy_product_name) {
          data.lamy_product_name = vm.filter.lamy_product_name
        }

        if (vm.filter.lamy_product_size) {
          data.lamy_product_size = vm.filter.lamy_product_size
        }

        if (vm.filter.lamy_product_head_type) {
          data.lamy_product_head_type = vm.filter.lamy_product_head_type
        }

        if (vm.filter.lamy_product_colour) {
          data.lamy_product_colour = vm.filter.lamy_product_colour
        }
      }

      if (vm.isGpfBuddy) {
        if (vm.filter.gpf_company_code && vm.filter.gpf_company_code.company_code !== 'All') {
          data.gpf_company_code = vm.filter.gpf_company_code.company_code
        }
        if (vm.filter.gpf_group_code && vm.filter.gpf_group_code.group_code !== 'All') {
          data.gpf_group_code = vm.filter.gpf_group_code.group_code
        }
        if (
          vm.filter.gpf_department_code &&
          vm.filter.gpf_department_code.department_code !== 'All'
        ) {
          data.gpf_department_code = vm.filter.gpf_department_code.department_code
        }
        if (vm.filter.gpf_position_code && vm.filter.gpf_position_code.position_code !== 'All') {
          data.gpf_position_code = vm.filter.gpf_position_code.position_code
        }
      }

      if (['toacrm'].includes(vm.selectedBot.theme)) {
        if (vm.filter.toa_member_tier) {
          data.toa_member_tier = vm.filter.toa_member_tier
        }
      }

      if (PAGE.JUZMATCH_CRM.includes(vm.selectedBot.pageid)) {
        if (vm.filter.juzmatch_member_role && vm.filter.juzmatch_member_role.value) {
          data.juzmatch_member_role = vm.filter.juzmatch_member_role.value
        }
      }

      if (['tcp-broadcast'].includes(this.selectedBot.type)) {
        if (vm.filter.tcp_type === 'member') {
          data.tags = vm.filter.tcp_tags.join(',')
          if (vm.filter.tcp.pdpa && vm.filter.tcp.pdpa.value !== 'all') {
            data.tcp_pdpa = vm.filter.tcp.pdpa.value
          }
          if (vm.filter.tcp.member_level && vm.filter.tcp.member_level.value !== 'all') {
            data.tcp_member_level_id = vm.filter.tcp.member_level.value
          }
        }
      }

      var messages = vm.checkEmptyMessage(vm.messages)

      if (isSend == true && (messages.length == 0 || messages[0].length == 0)) {
        callback(false)
        return false
      }

      data.m_val = JSON.stringify(messages)
      if (['line-group'].includes(this.groupTypeLine.value)) {
        const payload = {
          broadcast_id: data.broadcastid ? +data.broadcastid : null,
          name: data.name,
          group_ids: null,
          broadcast_group_tags: data.update_tags ? data.update_tags : null,
          broadcast_group_status: data.update_status ? data.update_status : null,
          status: data.sendflag ? 'sent' : 'draft',
          schedule_timestamp: !this.broadcast.isschedule ? null : data.scheduletime,
          messages: messages && messages[0],
          quick_reply: data.m_quick_reply,
          notify: data.notify
        }
        vm.$emit('onSave', {
          data: payload,
          onSave: function (status, broadcastid) {
            if (status) {
              if (broadcastid) {
                data.id = broadcastid
              }
              vm.broadcast = data
              vm.cached_broadcast = Object.assign({}, vm.broadcast)
            }
            callback(status)
          }
        })
      } else {
        vm.$emit('onSave', {
          data: data,
          onSave: function (status, broadcastid) {
            if (status) {
              if (broadcastid) {
                data.id = broadcastid
              }
              vm.broadcast = data
              vm.cached_broadcast = Object.assign({}, vm.broadcast)
            }
            callback(status)
          }
        })
      }
    },
    estimateReach: function (type) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        include_page_audience_ids: vm.filter.include_page_audience_ids
      }
      if (type === 'customize') {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            vm.filter.uu_areaname = vm.selectedBot.uu_areaname
          }
        }
        data.filter = vm.filter
        if (data.filter.uu_areaname == 'ทุกพื้นที่') {
          data.filter.uu_areaname = ''
        }

        // LAMY
        if (vm.isLamy) {
          if (vm.filter.lamySendNotiMember) {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember,
              lamy_member_expired_day: vm.filter.lamyDaySendNoti
            })
          } else {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember
            })
          }

          if (vm.filter.lamy_member_type) {
            if (vm.filter.lamy_member_type.length > 0) {
              const tempData = vm.filter.lamy_member_type.map((el) => {
                return el.value
              })
              Object.assign(data, {
                lamy_member_type: tempData.toString()
              })
            }
          }

          if (vm.filter.lamy_interested_product_type) {
            Object.assign(data, {
              lamy_interested_product_type: vm.filter.lamy_interested_product_type
            })
          }

          if (vm.filter.lamy_total_purchase_from) {
            Object.assign(data, {
              lamy_total_purchase_from: vm.filter.lamy_total_purchase_from
            })
          }

          if (vm.filter.lamy_total_purchase_to) {
            Object.assign(data, {
              lamy_total_purchase_to: vm.filter.lamy_total_purchase_to
            })
          }

          if (vm.filter.lamy_total_product_purchase_from) {
            Object.assign(data, {
              lamy_total_product_purchase_from: vm.filter.lamy_total_product_purchase_from
            })
          }

          if (vm.filter.lamy_total_product_purchase_to) {
            Object.assign(data, {
              lamy_total_product_purchase_to: vm.filter.lamy_total_product_purchase_to
            })
          }

          if (vm.filter.lamy_product_category) {
            if (vm.filter.lamy_product_category.length > 0) {
              const tempData = vm.filter.lamy_product_category.toString()
              Object.assign(data, {
                lamy_product_category: tempData
              })
            }
          }

          if (vm.filter.lamy_product_model) {
            if (vm.filter.lamy_product_model.length > 0) {
              const tempData = vm.filter.lamy_product_model.toString()
              Object.assign(data, {
                lamy_product_model: tempData
              })
            }
          }

          if (vm.filter.lamy_product_name) {
            if (vm.filter.lamy_product_name.length > 0) {
              const tempData = vm.filter.lamy_product_name.toString()
              Object.assign(data, {
                lamy_product_name: tempData
              })
            }
          }

          if (vm.filter.lamy_product_size) {
            if (vm.filter.lamy_product_size.length > 0) {
              const tempData = vm.filter.lamy_product_size.toString()
              Object.assign(data, {
                lamy_product_size: tempData
              })
            }
          }

          if (vm.filter.lamy_product_head_type) {
            if (vm.filter.lamy_product_head_type.length > 0) {
              const tempData = vm.filter.lamy_product_head_type.toString()
              Object.assign(data, {
                lamy_product_head_type: tempData
              })
            }
          }

          if (vm.filter.lamy_product_colour) {
            if (vm.filter.lamy_product_colour.length > 0) {
              const tempData = vm.filter.lamy_product_colour.toString()
              Object.assign(data, {
                lamy_product_colour: tempData
              })
            }
          }
        }

        if (vm.isGpfBuddy) {
          if (vm.filter.gpf_company_code && vm.filter.gpf_company_code.company_code !== 'All') {
            Object.assign(data, {
              gpf_company_code: vm.filter.gpf_company_code.company_code
            })
          }
          if (vm.filter.gpf_group_code && vm.filter.gpf_group_code.group_code !== 'All') {
            Object.assign(data, {
              gpf_group_code: vm.filter.gpf_group_code.group_code
            })
          }
          if (
            vm.filter.gpf_department_code &&
            vm.filter.gpf_department_code.department_code !== 'All'
          ) {
            Object.assign(data, {
              gpf_department_code: vm.filter.gpf_department_code.department_code
            })
          }
          if (vm.filter.gpf_position_code && vm.filter.gpf_position_code.position_code !== 'All') {
            Object.assign(data, {
              gpf_position_code: vm.filter.gpf_position_code.position_code
            })
          }
        }

        if (['toacrm'].includes(vm.selectedBot.theme)) {
          if (vm.filter.toa_member_tier) {
            Object.assign(data, {
              toa_member_tier: vm.filter.toa_member_tier
            })
          }
        }

        if (PAGE.JUZMATCH_CRM.includes(vm.selectedBot.pageid)) {
          if (vm.filter.juzmatch_member_role && vm.filter.juzmatch_member_role.value) {
            Object.assign(data, {
              juzmatch_member_role: vm.filter.juzmatch_member_role.value
            })
          }
        }

        if (['tcp-broadcast'].includes(vm.selectedBot.type)) {
          if (vm.filter.tcp_type === 'member') {
            data.filter.tags = vm.filter.tcp_tags.join(',')

            if (vm.filter.tcp.pdpa && vm.filter.tcp.pdpa.value !== 'all') {
              data.filter.tcp_pdpa = vm.filter.tcp.pdpa.value
            } else {
              data.filter.tcp_pdpa = ''
            }
            if (vm.filter.tcp.member_level && vm.filter.tcp.member_level.value !== 'all') {
              data.filter.tcp_member_level_id = vm.filter.tcp.member_level.value
            } else {
              data.filter.tcp_member_level_id = ''
            }
          }
        }
      } else {
        Object.assign(data, { app: type })
      }

      vm.loadingEstimate = true
      if (['line'].includes(data.app) && ['line-group'].includes(this.groupTypeLine.value)) {
        if (!this.selectedBot.pageid) return
        lineBotGroupApi
          .getEstimateReach({
            pageId: this.selectedBot.pageid
          })
          .then((response) => {
            const { total } = response.data
            vm.total_user = total
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            vm.loadingEstimate = false
          })
      } else {
        api.estimateReach(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.loadingEstimate = false
            return
          }
          if (response.data) {
            vm.estimate_user = response.data.count
            vm.total_user = response.data.total
            vm.count_optin_daily = response.data.count_optin_daily
            vm.count_optin_daily_available = response.data.count_optin_daily_available
            vm.count_optin_weekly = response.data.count_optin_weekly
            vm.count_optin_weekly_available = response.data.count_optin_weekly_available
            vm.count_optin_monthly = response.data.count_optin_monthly
            vm.count_optin_monthly_available = response.data.count_optin_monthly_available
          } else {
            vm.estimate_user = 0
          }
          vm.$nextTick(function () {
            vm.loadingEstimate = false
          })
        })
      }
    },
    onSelectGroupType: function (type) {
      if (type.value === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(type.value)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(type.value)
      }
    },
    onSelectGroupTypeLine: function (type) {
      this.groupTypeLine = type
      this.estimateReach('line')
    },
    reset: function () {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)

        this.update_status = vm.broadcast.update_user_status
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__'
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                  }
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
                case 'include_page_audience_ids':
                  setTimeout(() => {
                    vm.filter.include_page_audience_ids =
                      value && value[1] ? value[1].replace(/[\[\]]/g, '').split(',') : []
                  })
                  break
              }
            }
          })
          if (f.length == 1) {
            vm.$nextTick(() => {
              vm.groupType =
                vm.groupTypeOptions
                  .filter((option) => option.value !== 'customize')
                  .find((option) => option.value === vm.filter.app) || vm.groupType
            })
          } else {
            if (!['tcp-broadcast'].includes(vm.selectedBot.type)) {
              vm.groupType = vm.groupTypeOptions[3]
            }
          }
        } else {
          vm.groupType = vm.groupTypeOptions[0]
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
        vm.sendtype =
          vm.value && vm.value.sendtype == 'opt_in_daily' ? 'NTN_BROADCAST' : vm.sendtype
        vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          try {
            vm.messages = JSON.parse(vm.broadcast.m_val)
          } catch (error) {
            console.error(error)
          }
        } else {
          let newGroup = []
          const group = vm.broadcast.m_val.split('||')
          group.map((messages) => {
            let newMessage = []
            const group_messages = messages.split('#nl')
            newMessage = group_messages
              .map((message) => {
                if (!isNaN(message)) {
                  return {
                    type: 'text',
                    text: message
                  }
                } else if (vm.isJsonParseable(message)) {
                  var messageParsed = JSON.parse(message)
                  return {
                    text: messageParsed.text,
                    buttons: messageParsed.buttons,
                    type: 'button'
                  }
                } else if (vm.isURL(message)) {
                  return {
                    type: 'image',
                    image_url: message
                  }
                } else {
                  return {
                    type: 'text',
                    text: message
                  }
                }
              })
              .filter(Boolean)
            return newMessage
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = {
          m_condition: null,
          name: null,
          m_type: 'json',
          m_quick_reply: null,
          m_val: null
        }
        vm.isSave = false
        vm.isFail = false
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.messages = [[]]
        vm.choice = ''
        vm.errorTag = []
        vm.errorUsertag = []
        vm.estimate_user = 0
      }
      vm.$nextTick(function () {
        if (vm.selectedBot.theme == 'universalutilities') {
          vm.groupType = {
            label: this.$t('Customize'),
            value: 'customize'
          }
        }

        if (vm.groupType.value == 'customize') {
          if (vm.$store.getters.getPackage == 'premium') {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      })

      if (vm.name == '') {
        vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
      }
    },
    async onSearchTag({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchTagTimeout) {
        clearTimeout(vm.updateSearchTagTimeout)
      }
      vm.updateSearchTagTimeout = setTimeout(async () => {
        try {
          const tags = await vm.getUserTagList(event)
          onComplete(tags)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchTagTimeout = null
      }, 1500)
    },
    handleTcpTypeChange() {
      this.filter = {
        ...this.createInitialFilter(),
        tcp_type: this.filter.tcp_type
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.send-type {
  /deep/ {
    > .v-input__control {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue